// extracted by mini-css-extract-plugin
export default {"root":"SupportingText-module__root___z4jGH","line":"SupportingText-module__line___qIa3V","danger":"SupportingText-module__danger___eJc6Q"};